import SignupModule from 'modules/Signup'

const Signup = () => {
  return (
    <div data-testid="page-signup">
      <SignupModule />
    </div>
  )
}

export default Signup
